import React from 'react';
import { selectUser } from '../auth/UserSlice';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { Stack, Paper, Avatar } from '@mui/material';
import { styled } from '@mui/system';
import PersonIcon from '@mui/icons-material/Person';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
}));

export function AvatarDisplay() {
  const userInfo = useSelector(selectUser);
  return (
    <>
      <Stack alignItems='center' justifyContent='center'>
        <Item>
          <Avatar
            sx={{
              width: '10vw',
              height: '10vw',
              maxWidth: '150px',
              maxHeight: '150px',
              minWidth: '50px',
              minHeight: '50px',
              backgroundColor: 'primary.main',
            }}
          >
            <PersonIcon
              sx={{
                width: '7vw',
                height: '7vw',
                maxWidth: '125px',
                maxHeight: '125px',
                minWidth: '40px',
                minHeight: '40px',
              }}
            />
          </Avatar>
        </Item>
        <Item>
          <Typography sx={{ fontWeight: 'bold' }}>
            {userInfo.firstName + ' ' + userInfo.lastName}
          </Typography>
        </Item>
        <Item>
          <Typography>{userInfo.email}</Typography>
        </Item>
      </Stack>
    </>
  );
}
